import { FileSearch, Users, LineChart, CheckCircle2 } from "lucide-react";

const STEPS = [
  {
    icon: FileSearch,
    title: "Free Utility Bill Review",
    text: "At no cost, our experts analyze your usage, current supply rate, and contract status to see if a switch makes sense. No obligations whatsover.",
  },
  {
    icon: Users,
    title: "Securing The Right Supplier",
    text: "We acquire and competitively negotiate quotes from the 60+ top industry rated suppliers in our network.",
  },
  {
    icon: LineChart,
    title: "Choose With Confidence",
    text: "You get a simple, easy to understand presentation showing rates, term lengths, fees, and flexible renewal conditions.",
  },
  {
    icon: CheckCircle2,
    title: "Seamless Switch",
    text: "Your utility keeps delivering with zero interruption, but now at a much lower cost. Welcome to BlueSettle.",
  },
];

export default function ProcessSection() {
  return (
    <section id="how-it-works" className="py-16 md:py-24 bg-[#F4F8FC]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <p className="text-s font-bold uppercase tracking-[0.2em] text-[#0066FF]">HOW IT WORKS</p>
          <h2 className="mt-3 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#0B1F44]">
            Commercial energy procurement, done right
          </h2>
          <p className="mt-4 text-base text-slate-600 leading-relaxed">
            Reduce your utility bill with zero disruptions. Learn how take care of everything from the bill review to a better rate with four easy steps:
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {STEPS.map((s, i) => (
            <div
              key={s.title}
              data-testid={`process-step-${i}`}
              className="group relative rounded-2xl bg-white p-6 sm:p-8 border border-slate-100 shadow-[0_10px_30px_-5px_rgba(11,31,68,0.08)] hover:shadow-[0_18px_45px_-8px_rgba(0,102,255,0.22)] hover:-translate-y-1 transition-all duration-300"
            >
              <span className="absolute top-6 right-7 font-display text-4xl font-extrabold text-[#E6EEF7] group-hover:text-[#0066FF]/20 transition-colors">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[#E6EEF7] text-[#0066FF] group-hover:bg-[#0066FF] group-hover:text-white transition-colors duration-300">
                <s.icon size={24} />
              </div>
              <h3 className="mt-5 text-lg font-semibold text-[#0B1F44]">{s.title}</h3>
              <p className="mt-2.5 text-sm text-slate-600 leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
